export enum CheckboxSize {
  S = 's',
  M = 'm',
  L = 'l',
  XL = 'xl',
}
